import { createContext, useContext } from 'react';
import { User } from '../../../types';
import { Nullable } from '@/ui-kit/types';

/**
 * user === null - no user, unauthorized
 * user === undefined - UseUserContext was not filled by provider
 */

export const UseUserContext = createContext<Nullable<User> | undefined>(undefined);

export const useUser = () => {
    const contextValue = useContext(UseUserContext);
    if (contextValue === undefined) {
        throw new Error(
            "No useUser defined with react context, pls implement: '<UseUserContext.Provider value={user}>{children}</UseUserContext.Provider>;'"
        );
    }
    return contextValue;
};
